<template>
  <div class="content">
    <div class="header">
      <el-page-header @back="goBack" :content="content"></el-page-header>
    </div>
    <div class="bottom">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      content: this.$route.meta.title
    };
  },
  mounted() {
    console.log("router", this.$route);
  },
  methods: {
    goBack() {
      console.log("router", this.$route);
      console.log("go back");
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  height: 100%;
  border: 1px solid #f1f1f1;
  display: flex;
  flex-direction: column;
  padding: 0px 24px;
  background: #fff;

  .header,
  .el-page-header {
    line-height: 50px;
  }
  .bottom {
    flex: 1;
    overflow-y: scroll;
    border-top: 1px solid #dcdfe6;

    // background: rgba(240, 242, 245, 1);
  }
}
</style>
